export default {
  code: "Code",
  name: "Name",
  invoice: "Invoice",
  taxes: "Taxes",
  tax: "Tax",
  taxCreated: "Tax created successfully",
  taxUpdated: "Tax updated successfully",
  taxesDeleted: "Taxes deleted successfully",
  createNewTax: "Create new tax",
  editTax: "Edit tax",
  taxCode: "Tax Code",
  taxRate: "Tax Rate",
  taxName: "Tax Name",
  taxDescription: "Tax Description",
};
